import { useQuery } from '@tanstack/react-query';
import { GetPaymentMethods } from '../api';
import { pickPaymentMethod, type PaymentMethod } from '../../payments/methods';

/**
 * The payment methods platform admins have switched on (and the server can take) for a plan
 * checkout or a coin top-up, so checkout never offers one the server would refuse. `pick` keeps
 * the user's choice while it is offered and otherwise falls back to the first offered method.
 */
export function usePaymentMethods(enabled: boolean, checkout: 'plan' | 'coins') {
  const query = useQuery({
    queryKey: ['payments', 'methods'],
    queryFn: async () => (await GetPaymentMethods()).data,
    enabled,
    staleTime: 60_000,
  });
  const methods: PaymentMethod[] = query.data?.[checkout] ?? [];
  const pick = (chosen: PaymentMethod | null) => pickPaymentMethod(methods, chosen);
  return { methods, pick, isLoading: query.isLoading, isError: query.isError };
}
